// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__sJe2g","buttons":"RemoveExpirationActionButtons_buttons__3EMho"};